import QueryResults from "./QueryResults";

export default class QueryResults_Manifesti extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, type, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
    this.type = type;
    this.createPanelTypes();
  }

  createPanelTypes() {
    const panel = jQuery("#template-types").clone();
    panel.removeAttr("id");
    this.target.append(panel);
    for (let name in QueryResults_Manifesti.FIELDS) {
      const entry = jQuery("#template-type-fields").clone();
      entry.removeAttr("id");
      entry.text(name);
      entry.click(() => {
        const oldType = this.type;
        this.type = name;
        this.changeView(oldType);
        jQuery(".is-active", panel).removeClass("is-active");
        entry.addClass("is-active");
      });
      if (name === this.type) {
        entry.addClass("is-active");
      }
      panel[0].querySelector(".types-container").append(entry[0]);
    }
  }

  changeView(oldType) {
    const oldfields = QueryResults_Manifesti.FIELDS[oldType];
    this.grid.setColumnsVisible(oldfields, false);
    const newfields = QueryResults_Manifesti.FIELDS[this.type];
    this.grid.setColumnsVisible(newfields, true);
    // Pezza per riadattare la prima volta le colonne (è da fare meglio)
    if (!this["shown_" + this.type]) {
      this["shown_" + this.type] = true;
      this.doResize();
    }
  }

  getColumns() {
    let columnDefs = [
      // Filmografia
      this.fr.fieldFilmografia(),
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Media
      this.fr.fieldMedia(),

      // Customs
      this.fr.filmografiaNCTN(),
      this.fr.filmografiaTitolo(),
      this.fr.filmografiaData(),
      this.fr.filmografiaRegista(),

      // NCNT
      this.fr.fieldList("numero_catalogo_generale_NCTN", "NCNT", 1, this.dispatch.bind(this), "MANIFESTI_numero_catalogo_generale_NCTN"),
      // RVEL
      this.fr.fieldPlain("livello_RVEL", "Livello", 1),
      // Specifiche e note
      this.fr.fieldPlain("specifiche_LDCS", "Specifiche e note", 2),
      // Num. Inv.
      this.fr.fieldList("inventario_INV", "Num. Inv.", 1, null, null, "numero_INVN"),
      // Definizione
      this.fr.fieldList("definizione_oggetto_OGTD", "Oggetto", 2, this.dispatch.bind(this), "MANIFESTI_definizione_oggetto_OGTD"),
      // Titolo
      this.fr.fieldPlain("label", "Titolo", 2),
      // Nome autore
      this.fr.fieldList("entities", "Nome autore", 2, this.dispatch.bind(this), "MANIFESTI_autore", "label", null, "relation_type_code", "disegnatore_autr", null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "entities.rel_entity_id", key: "rel_entity_id" }),
      // Altezza
      this.fr.fieldList(["misure_MIS", "altezza_MISA"], "Altezza", 2, null, null, ["altezza_MISA", "unita_misura_MISU"], ""),
      // Larghezza
      this.fr.fieldList(["misure_MIS", "larghezza_MISL"], "Larghezza", 2, null, null, ["larghezza_MISL", "unita_misura_MISU"], ""),
      // Varie misure
      this.fr.fieldList("varie_MISV", "Misure varie", 2),
    ];
    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }

  isHidden(field) {
    const list = QueryResults_Manifesti.FIELDS[this.type];
    return list.indexOf(field) === -1;
  }
}

QueryResults_Manifesti.QUERY_numero_catalogo_generale_NCTN = {
  id: "QN1731341495411",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731341495412",
      Field: {
        _path: "/numero_catalogo_generale_NCTN",
        _label: "/numero_catalogo_generale_NCTN",
        Name: "numero_catalogo_generale_NCTN",
        Label: "numero_catalogo_generale_NCTN",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "MANIFESTI_coll",
};

QueryResults_Manifesti.QUERY_definizione_oggetto_OGTD = {
  id: "QN1731342127813",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731342127819",
      Field: {
        _path: "/definizione_oggetto_OGTD",
        _label: "/definizione_oggetto_OGTD",
        Name: "definizione_oggetto_OGTD",
        Label: "definizione_oggetto_OGTD",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "MANIFESTI_coll",
};

QueryResults_Manifesti.QUERY_autore = {
  id: "QN1731341870449",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731341870450",
      Field: {
        _path: "/entities",
        _label: "/entities",
        Name: "entities",
        Label: "entities",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731341870451",
          Field: {
            _path: "/entities/relation_type_code",
            _label: "/entities/relation_type_code",
            Name: "relation_type_code",
            Label: "relation_type_code",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
            Lookup: "MANIFESTI_entities_relation_types",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "disegnatore_autr",
          Compare: "sEQUALS",
        },
        {
          id: "QN1731341870452",
          Field: {
            _path: "/entities/label",
            _label: "/entities/label",
            Name: "label",
            Label: "label",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "dummy",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "MANIFESTI_coll",
};

QueryResults_Manifesti.TYPE_CON_FILM = "con filmografia";
QueryResults_Manifesti.TYPE_SENZA_FILM = "senza filmografia";

QueryResults_Manifesti.FIELDS = {
  "con filmografia": ["fncnt", "flabel", "fdata", "fregia", "livello_RVEL", "numero_catalogo_generale_NCTN", "specifiche_LDCS", "inventario_INV", "definizione_oggetto_OGTD", "label", "entities", "altezza_MISA", "larghezza_MISL", "varie_MISV"],
  "senza filmografia": ["livello_RVEL", "numero_catalogo_generale_NCTN", "specifiche_LDCS", "inventario_INV", "definizione_oggetto_OGTD", "label", "entities", "altezza_MISA", "larghezza_MISL", "varie_MISV"],
};
